import { QueryBuilderState } from '@modules/queryBuilder/store/types';
import { EqlField, EqlFieldValue } from 'generated/graphql';

interface GetEqlFieldByFieldIDOptions {
  eqlField: EqlField;
  eqlFieldByFieldID: QueryBuilderState['metadata']['eqlFieldByFieldID'];
  eqlFieldValue: EqlFieldValue | undefined;
}

export const getEqlFieldByFieldID = ({
  eqlField,
  eqlFieldByFieldID,
  eqlFieldValue,
}: GetEqlFieldByFieldIDOptions): QueryBuilderState['metadata']['eqlFieldByFieldID'] => {
  if (!eqlField) {
    return eqlFieldByFieldID;
  }

  return {
    ...eqlFieldByFieldID,
    [eqlField.field]: {
      field: eqlField,
      eqlFieldValueByID: {
        ...eqlFieldByFieldID[eqlField.field]?.eqlFieldValueByID,
        ...(eqlFieldValue
          ? {
              [String(eqlFieldValue.value)]: {
                __typename: 'EQLFieldValue',
                value: eqlFieldValue.value ?? '',
                displayName: eqlFieldValue.displayName ?? '',
                iconURL: eqlFieldValue.iconURL ?? '',
              },
            }
          : {}),
      },
    },
  };
};
